export const RECORRIDO = {
  newButton: 'recorrido-new-button',
  list: 'recorrido-list',
  row: 'recorrido-row',
  detailBack: 'recorrido-detail-back',
  deleteButton: 'recorrido-delete-button',
  formTitulo: 'recorrido-form-titulo',
  formUbicacion: 'recorrido-form-ubicacion',
  formEstado: 'recorrido-form-estado',
  formSeveridad: 'recorrido-form-severidad',
  formNovedad: 'recorrido-form-novedad',
  formSubmit: 'recorrido-form-submit',
  reportButton: 'recorrido-report-button',
  reportPrint: 'recorrido-report-print',
};
